import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";
import {Accordion, AccordionSummary, AccordionDetails} from "@material-ui/core";

const ExpansionPanelV = withStyles({
    root: {
        border: "1px solid rgba(0,0,0,.125)",
        boxShadow: "none",
        // "&:not(:last-child)": {
        //     borderBottom: 0
        // },
        // "&:before": {
        //     display: "none"
        // },
        // '&$expanded': {
        //     margin: '0'
        // }
    },
    expanded: {
        margin: "auto"
    }
})(Accordion);
const ExpansionPanelSummaryV = withStyles({
    root: {
        // backgroundColor: "rgba(0,0,0,.03)",
        // borderBottom: "1px solid rgba(0,0,0,.125)",
        // marginBottom: -1,
        // padding: '0 24px 0 8px',
        // minHeight: 35,
        // "&$expanded": {
        //     minHeight: 35
        // }
    },
    expandIcon: {
        padding: 0
    },
    content: {
        margin: "0 0",
        '&>p': {
            fontSize: '0.875rem'
        },
        "&$expanded": {
            margin: "8px 0",
        }
    },
    expanded: {}
})(props => <AccordionSummary {...props} />);
const ExpansionPanelDetailsV = withStyles(theme => ({
    root: {
        padding: theme.spacing(1),
        display: 'block'
    }
}))(AccordionDetails);

const ExpansionPanelUnstyled = withStyles({
    root: {
        // border: "1px solid rgba(0,0,0,.125)",
        boxShadow: "none",
        // "&:not(:last-child)": {
        //     borderBottom: 0
        // },
        "&:before": {
            display: "none"
        },
        '&$expanded': {
            margin: '0'
        }
    },
    expanded: {}

})(Accordion);
const ExpansionPanelSummaryUnstyled = withStyles({
    root: {
        padding: '0',
        minHeight: 'auto',
        display: 'inline-flex',
        flexGrow: 'initial',
        '&$expanded': {
            minHeight: 35,
        },
    },
    expandIcon: {
        padding: 0
    },
    content: {
        margin: "4px 0",
        '&>p': {
            fontSize: '0.875rem'
        },
        "&$expanded": {
            margin: "12px 0",
        }
    },
    expanded: {
    }
})(props => <AccordionSummary {...props} />);
const ExpansionPanelDetailsUnstyled = withStyles(theme => ({
    root: {
        padding: theme.spacing(1),
        display: 'block'
    }
}))(AccordionDetails);


export {
    ExpansionPanelV,
    ExpansionPanelSummaryV,
    ExpansionPanelDetailsV,
    ExpansionPanelUnstyled,
    ExpansionPanelSummaryUnstyled,
    ExpansionPanelDetailsUnstyled,

}
